
export enum AuthScreen {
  HOME = 'HOME',
  LOGIN = 'LOGIN',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  VERIFY_CODE = 'VERIFY_CODE',
  NEW_PASSWORD = 'NEW_PASSWORD',
  SUCCESS = 'SUCCESS',
  DASHBOARD = 'DASHBOARD'
}

export type DashboardView =
  | 'DASHBOARD_HOME'
  | 'LIVE_MAP'
  | 'METHANE_TRENDS'
  | 'METHANE_CONVERTER'
  | 'DATA_COMPARISON'
  | 'DATA_TABS'
  | 'MANAGE_DATA'
  | 'ALERTS'
  | 'USER_MANAGEMENT'
  | 'FIELD_DATA'
  | 'SETTINGS'
  | 'DATA_FEEDS'
  | 'DOCS';
